
import { ServiceWorkerUtils } from '@ajin/utils/service-worker.utils';
import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, importProvidersFrom, inject, isDevMode } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ActivatedRoute, PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideFuse } from '@fuse/fuse.provider';
import { TranslocoService, provideTransloco } from '@ngneat/transloco';
import { provideIcons } from '@projects/core/icons/icons.provider';
import { TranslocoHttpLoader } from '@projects/core/transloco/transloco.http-loader';
import { firstValueFrom } from 'rxjs';
import { appRoutes } from './app.routing';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { themes } from '@ajin/config/ajin.themes';
import { provideAuth } from '@projects/core/auth/auth.provider';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
    providers: [
        provideServiceWorker(
            'ngsw-worker.js', {
            enabled: !isDevMode()
                && ServiceWorkerUtils.activeInPlatform(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        provideAnimations(),
        provideHttpClient(),
        provideRouter(appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
        ),

        importProvidersFrom(MatNativeDateModule),
        { provide: LOCALE_ID, useValue: 'pt-BR' },

        // Transloco Config
        provideTransloco({
            config: {
                availableLangs: [
                    {
                        id: 'pt',
                        label: 'Português'
                    },
                    {
                        id: 'en',
                        label: 'English'
                    }
                ],
                defaultLang: 'pt',
                fallbackLang: 'pt',
                reRenderOnLangChange: true,
                prodMode: true,
            },
            loader: TranslocoHttpLoader,
        }),
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                const translocoService = inject(TranslocoService);
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);

                return () => firstValueFrom(translocoService.load(defaultLang));
            },
            multi: true,
        },

        provideAuth(),
        provideIcons(),
        provideFuse({

            fuse: {
                layout: 'classy',
                scheme: 'dark',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px'
                },
                theme: 'theme-green',
                themes: themes
            }
        }),
    ],
};
